import { SelectButton } from 'primereact/selectbutton';

export interface SegmentOption<T extends string> {
  label: string;
  value: T;
}

export interface BaseSegmentedControlProps<T extends string> {
  value: T;
  options: readonly SegmentOption<T>[];
  onChange: (value: T) => void;
  'aria-label': string;
  className?: string;
}

/**
 * Pill-shaped single-choice switch (theme switch, Firm-wide / My work scope).
 * Selecting the current option again keeps it selected.
 */
export function BaseSegmentedControl<T extends string>({
  value,
  options,
  onChange,
  className,
  'aria-label': ariaLabel,
}: BaseSegmentedControlProps<T>) {
  return (
    <SelectButton
      value={value}
      options={[...options]}
      optionLabel="label"
      optionValue="value"
      allowEmpty={false}
      aria-label={ariaLabel}
      className={className}
      onChange={(e: { value: T | null }) => {
        if (e.value !== null) onChange(e.value);
      }}
    />
  );
}
